import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import ReferenceIcon from '@material-ui/icons/HowToRegOutlined';

import classes from '../../css/getCSS';

const referenceInfo = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('referenceinfo')}>Edit</Button>
    );
  }
  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <ReferenceIcon className={classes.titleIcon} />
          Reference
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Name</p>
            <p className={classes.profileVal}>{props.profile.referenceinfo.name}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Contact no.</p>
            <p className={classes.profileVal}>{props.profile.referenceinfo.phone}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Place</p>
            <p className={classes.profileVal}>{props.profile.referenceinfo.place}</p>
            <br />
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default referenceInfo;



// WEBPACK FOOTER //
// ./src/profile/components/ReferenceInfo.js